import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from '../../../share/guards'
import SourceAreaEmptyResultGuard from './SourceAreaEmptyResultGuard'

const SourceAreaWidgetDataGuards = ({
  widgetId,
  children
}: {
  widgetId: number
  children: React.ReactElement
}) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <SourceAreaEmptyResultGuard widgetId={widgetId}>{children}</SourceAreaEmptyResultGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default SourceAreaWidgetDataGuards
